angular.module('tasks')
    .directive('dashboardTaskItemSmall', function ($rootScope, TaskService, Task, Document, toastr, DashboardTaskOpenService) {
        return {
            restrict: 'E',
            scope: {
                task: '='
            },
            templateUrl: 'app/task/dashboard-task-item-small.tpl.html',
            link: function (scope, element, attr) {
                scope.DashboardTaskOpenService = DashboardTaskOpenService;
                scope.TaskService = TaskService;

                scope.isTaskOpen = () => DashboardTaskOpenService.taskOpened != null && DashboardTaskOpenService.taskOpened.id === scope.task.id;

                scope.openTask = () => {
                    if (scope.isTaskOpen()) {
                        DashboardTaskOpenService.taskOpened = null;
                        DashboardTaskOpenService.taskOpenedComments = null;
                        DashboardTaskOpenService.newComment = {};
                    } else {
                        DashboardTaskOpenService.taskOpened = scope.task;
                        DashboardTaskOpenService.taskOpenedComments = null;
                        DashboardTaskOpenService.newComment = {};
                        refreshOpenedTask(scope.isTaskOpen());
                    }
                };

                scope.postTaskComment = (task, comment) => {
                    scope.isSaving = true;
                    return Document.postComment({type: 'task', id: task.id}, comment).$promise
                        .then(() => {
                            DashboardTaskOpenService.newComment = {};
                            $rootScope.$broadcast('task.updated');
                            toastr.success("Zapisano");
                            scope.isSaving = false;
                        })
                        .catch(() => {
                            toastr.error("Nie zapisano. Spróbuj ponownie");
                            scope.isSaving = false;
                        })
                };

                function refreshOpenedTask(isTaskOpen) {
                    if (isTaskOpen) {
                        DashboardTaskOpenService.taskOpen = scope.task;
                        Document.comments({id: scope.task.id, type: 'task'}).$promise.then(comments => {
                            DashboardTaskOpenService.taskOpenedComments = comments;
                        });
                    }
                }

                scope.$on('task.updated', () => refreshOpenedTask(scope.isTaskOpen()));
                scope.$on('task.deleted', () => refreshOpenedTask(scope.isTaskOpen()));

            }
        };
    });
